import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import ContentChannels from "../ContentChannel/ContentChannels";
import ContentChannel from "../ContentChannel/ContentChannel";
import VODsPage from "./VOD/VODsPage";
import { VODPage } from "./VOD/VODPage";
import LiveChannels from "./LiveChannels/LiveChannels";
import { LiveChannel } from "./LiveChannels/LiveChannel";
import Tags from "./Tags/Tags";
import { Tag } from "./Tags/Tag";
import BulkIngestListPage from "./BulkIngest/BulkIngestListPage";
import BulkIngestDetailPage from "./BulkIngest/BulkIngestDetailPage";
import { store } from "../../store";
import { GetGenresAction, getIsLoading } from "../../store/reducers/cmsReducer";
import { useSelector } from "react-redux";
import { Loader } from "../../../Loader/Loader";

const CMS: React.FC = () => {
  const isLoading = useSelector(getIsLoading);

  useEffect(() => {
    store.dispatch(GetGenresAction());
  }, []);

  return (
    <>
      <Loader loading={isLoading} />
      <Routes>
        <Route path="effect-channels" element={<ContentChannels />} />
        <Route path="effect-channels/:channelId" element={<ContentChannel />} />
        <Route path="vod" element={<VODsPage />} />
        <Route path="vod/:id" element={<VODPage />} />
        <Route path="live-channels" element={<LiveChannels />} />
        <Route path="live-channels/:id" element={<LiveChannel />} />
        <Route path="tags" element={<Tags />} />
        <Route path="tags/:id" element={<Tag />} />
        <Route path="bulk-ingest" element={<BulkIngestListPage />} />
        <Route path="bulk-ingest/:id" element={<BulkIngestDetailPage />} />
      </Routes>
    </>
  );
};

export default CMS;
